import React from 'react';
import { CustomButton } from '../../../../../components/Button';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../../../constants/language';
import { Box, Dialog, Typography } from '@mui/material';

const DeliveryModal: React.FC<{ open: boolean; handleSubmit: Function; handleClose: Function }> = ({ handleClose, open, handleSubmit }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      aria-labelledby="hint-dialog-title"
      aria-describedby="hint-dialog-description"
    >
      <Box
        sx={{
          width: '100%',
          background: 'var(--Base-White, #FFF)',
          borderRadius: '12px',
          boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
        }}
      >
        <Box sx={{ padding: '24px 16px', display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center' }}>
          <Typography fontSize={14} lineHeight="20px" color="var(--Gray-600, #475467)" textAlign="center">
            {t(LANG_TEXT.ORDER_ALREADY_ACCEPTED)}
          </Typography>

          <CustomButton
            variant="contained"
            padding="8px 24px"
            onClick={(e) => {
              handleSubmit();
              e.stopPropagation();
            }}
          >
            {t(LANG_TEXT.CONFIRM)}
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeliveryModal;
